import { useEffect } from 'react';
import throttle from 'lodash/throttle';

const WINDOW_RESIZE_THROTTLE_DELAY_MS = 250;

export const useResizeEventListeners = (update: () => void) => {
  useEffect(() => {
    const handleWindowResize = throttle(update, WINDOW_RESIZE_THROTTLE_DELAY_MS, {
      leading: true,
      trailing: true,
    });

    window?.addEventListener('resize', handleWindowResize);
    window?.addEventListener('orientationchange', handleWindowResize);

    return () => {
      window?.removeEventListener('resize', handleWindowResize);
      window?.removeEventListener('orientationchange', handleWindowResize);
    };
  }, [update]);
};
